export default theme => ({
  actionBtns: {
    margin: "0 0 1% 0",
    [theme.breakpoints.down("xs")]: {
      width: "100%"
    }
  }
});
